import React, {useRef, useState, useEffect} from 'react';
import {Animated, Pressable} from 'react-native';
import Text from '../../elements/Text';
import {DLog} from '../../../utils/HelperMethods';

import {Images} from '../../../utils/Images';

import makeStyles from './styles';
import {useThemedStyles} from '../../../theme';
import {COLORS} from '../../../utils/Constants';
import {tID} from '../../../utils/TestIdHelper';

const LoadingModal = ({
  closeLoader,
  testID = tID('LoadingModal-Pressable-Main'),
  showCloseLoader = true,
}) => {
  const styles = useThemedStyles(makeStyles);
  const fadeAnim = useRef(new Animated.Value(0)).current;
  const fadeAnimLogo = useRef(new Animated.Value(1)).current;
  const [canCloseLoader, setCanCloseLoader] = useState(false);

  useEffect(() => {
    let timer = setTimeout(() => {
      setCanCloseLoader(true);
    }, 5000);
    return () => {
      clearTimeout(timer);
    };
  }, []);

  useEffect(() => {
    Animated.timing(fadeAnim, {
      toValue: 1,
      duration: 100,
      useNativeDriver: false,
    }).start();
  }, [fadeAnim]);

  useEffect(() => {
    const animation = Animated.loop(
      Animated.sequence([
        Animated.timing(fadeAnimLogo, {
          toValue: 0,
          duration: 800,
          useNativeDriver: false,
        }),
        Animated.timing(fadeAnimLogo, {
          toValue: 1,
          duration: 800,
          useNativeDriver: false,
        }),
      ]),
    );
    animation.start();
    return () => {
      animation.stop();
    };
  }, [fadeAnimLogo]);

  const closeLoaderIfMeetsCondition = () => {
    // DLog('closeLoaderIfMeetsCondition');
    if (canCloseLoader && showCloseLoader) closeLoader();
  };

  return (
    <Pressable
      testID={testID}
      onPress={() => closeLoaderIfMeetsCondition()}
      style={styles.pressableStyle}
    >
      <Animated.View
        testID={tID('LoadingModal-AnimatedView-Container')}
        style={styles.container(fadeAnim)}
      >
        <Animated.Image
          testID={tID('LoadingModal-AnimatedImage-Logo')}
          source={Images.logo}
          style={styles.logo(fadeAnimLogo)}
        />
        {canCloseLoader && showCloseLoader && (
          <>
            <Text
              testID={tID('LoadingModal-Text-Title')}
              // On the always-dark scrim — keeps legacy light-grey in both themes
              color={COLORS.grey4}
              variation="Body1Bold"
              style={styles.helperText}
              topMargin={32}
            >
              Oops! This is taking longer than usual.
            </Text>
            <Text
              testID={tID('LoadingModal-Text-Close')}
              color={COLORS.grey4}
              variation="Body1Bold"
              style={styles.helperText}
              topMargin={4}
            >
              Tap to close.
            </Text>
          </>
        )}
      </Animated.View>
    </Pressable>
  );
};

export default LoadingModal;
